import includes from 'lodash/includes';

import type { DetectorParams } from '../types';
import { referralAndTextRoutes, seoRoutes } from '../const';

/**
 * Detect the direct-seo channel
 */
export const isDirectSeoChannelFn = ({
  utmSource,
  firstUrl,
  firstReferer,
  referrerMedium,
}: DetectorParams): boolean => {
  if (utmSource) {
    return false;
  }

  if (referralAndTextRoutes.some((v) => includes(firstUrl?.pathname, v))) {
    return false;
  }

  return (
    seoRoutes.some((v) => includes(firstUrl?.href, v)) &&
    !includes(firstUrl?.href, 'fbclid=') &&
    !includes(firstUrl?.href, 'gclid=') &&
    (!referrerMedium || referrerMedium === 'internal') &&
    (!firstReferer || (!includes(firstReferer, 'facebook') && !includes(firstReferer, 'tiktok')))
  );
};
